import React, { createContext, useEffect, useState, useContext, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'

export const themes = {
  light: {
    '--nav-primary': '#666666',
    '--nav-active': '#182c49',

    '--form-field-background': '#0e192a',

    '--body-title': '#182c49',

    '--primary': '#5e5e5e',
    '--primary-info': '#1d317d',
    '--primary-grey': '#666666',
    '--primary-container': '#ffffff',
    '--primary-container-dark': '#182c49',

    '--course-container': '#f8f9fa',

    '--secondary': '#ffffff',
    '--secondary-container': '#182c49',

    '--pagination': '#17a2b8',
    '--button-outline': '#17a2b8',
    '--button-outline-text': '#17a2b8',
    '--button-outline-text-hover': '#ffffff',
    '--tabs-active': '#00a4eb',
    '--tabs-inactive': '#86d2f3',
    '--tabs-inactive-text': '#ffffff',
    '--icon-outline': 'transparent',
    '--mark-down-link': '#1d317d',
    '--custom-banner': '#f4f4f4'

  },
  dark: {
    '--nav-primary': '#cecece',
    '--nav-active': '#00a4eb',

    '--form-field-background': '#292929',

    '--body-title': '#ffffff',

    '--primary': '#ffffff',
    '--primary-info': '#0063aa',
    '--primary-grey': '#ffffff',
    '--primary-container': '#292929',
    '--primary-container-dark': '#ffffff14',

    '--course-container': '#292929',

    '--secondary': '#343a40',
    '--secondary-container': '#191919',

    '--pagination': '#ffffff',
    '--button-outline': '#00a8c3',
    '--button-outline-text': '#08d8f9',
    '--button-outline-text-hover': '#ffffff',
    '--tabs-active': '#00a4eb',
    '--tabs-inactive': '#7a7a7a',
    '--tabs-inactive-text': '#c7c7c7',
    '--icon-outline': '#00a4eb',
    '--mark-down-link': '#00A4EB',
    '--custom-banner': '#ffffff14'
    

  }
}

const ThemeContext = createContext(null)

// const { theme, setTheme, toggleTheme } = useTheme()
export const useTheme = () => useContext(ThemeContext)

// cambiar si cambia el tema por defecto
// const DEFAULT_THEME = 'light'

const ThemeProvider = ({ children }) => {
  const DEFAULT_THEME = 'light'

  const [theme, setTheme] = useState(null)


  //Antes de renderizar la pantalla se selecciona el tema: localStorage o tema del sistema

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return
    const localTheme = localStorage.getItem('theme')
    if (localTheme) {
      setTheme(localTheme)
      return
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark')
    } else {
      setTheme(DEFAULT_THEME)
    }
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return
    localStorage.setItem('theme', theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'))
  }
  
  if (!theme) return null // Aseguramos que el tema sea provisto cuando se detecte el tema completamente.
  
  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      <div style={{ ...themes[theme], background: 'var(--primary-container)' }}>{children}</div>
    </ThemeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.object
}

export default ThemeProvider
